import { useEffect } from "react";
import { useMe } from "lib/auth";
import { useTranslation } from "react-i18next";

// faviconは、まずSSRのタイミング（_document）で、Accept-Languageヘッダーからロケールを推定し、それに応じたデフォルトのfaviconを表示します。
// 「ja（日本語）」の場合は /favicon/kana、それ以外のロケール（英語・中国語など）の場合は/favicon/alphabet ディレクトリ以下のファイルを使用しています。
// その後、ユーザーがログインしてデータベース上の言語設定を取得できるようになると、このコンポーネントでその設定に基づいたfaviconに上書きします。
const Favicon: React.FC = () => {
  const me = useMe();
  const { t } = useTranslation("common");

  useEffect(() => {
    if (!me?.languageCode) return;

    const head = document.querySelector("head");
    if (!head) return;

    const isKana = me.languageCode === "ja";
    const basePath = isKana ? "/favicon/kana" : "/favicon/alphabet";

    // favicon関連のlinkタグを削除
    head
      .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"], link[rel="manifest"]')
      .forEach((el) => el.parentNode?.removeChild(el));

    // favicon関連のmetaタグを削除
    head.querySelectorAll('meta[name="apple-mobile-web-app-title"]').forEach((el) => el.parentNode?.removeChild(el));

    const createLink = (rel: string, href: string, type?: string, sizes?: string, color?: string) => {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = href;
      if (type) link.type = type;
      if (sizes) link.setAttribute("sizes", sizes);
      if (color) link.setAttribute("color", color);
      head.appendChild(link);
    };

    const createMeta = (name: string, content: string) => {
      const meta = document.createElement("meta");
      meta.name = name;
      meta.content = content;
      head.appendChild(meta);
    };

    // 必要な favicon 種類を挿入
    if (isKana) {
      createLink("icon", `${basePath}/favicon-96x96.png`, "image/png", "96x96");
      createLink("icon", `${basePath}/favicon.svg`, "image/svg+xml");
    } else {
      createLink("icon", `${basePath}/favicon-32x32.png`, "image/png", "32x32");
      createLink("icon", `${basePath}/favicon-16x16.png`, "image/png", "16x16");
    }

    createLink("apple-touch-icon", `${basePath}/apple-touch-icon.png`, "image/png", "180x180");
    createLink("manifest", `${basePath}/site.webmanifest`);

    // ニトエル or Nitoel
    createMeta("apple-mobile-web-app-title", t("service_name"));
  }, [me?.languageCode, t]);

  return null;
};

export default Favicon;
